<template>
  <div class="login-page header-wrapper animate fadeIn">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
          <div class="block-border radius block shadow">
            <page-register-form submit-button-text="เข้าสู่ระบบ" :back-button="false" @submit="success" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PageRegisterForm from './PageRegisterForm.vue'

export default {
  components: {PageRegisterForm},
  name: 'LoginPage',
  data () {
    return {
      submitting: false,
      email: '',
      password: '',
      fbVisible: false,
      $v: {}
    }
  },
  created () {
    if (this.$store.state.token) {
      this.$router.push(`/${process.env.MAIN_PRODUCT_SKU}`)
    }

    this.$v = this.$validator.init(this, {
      email: {
        checkEmpty: true,
        checkEmail: true
      },
      password: {
        checkEmpty: true
      }
    })
  },
  methods: {
    success () {
      if (this.$route.query.next) {
        this.$router.push(this.next)
      } else {
        this.$router.push(`/${process.env.MAIN_PRODUCT_SKU}`)
      }
    },
    doLogin (payload) {
      this.$http.post('members/login', payload, { autoLogout: false })
        .then(resp => {
          this.submitting = false
          this.$modal.hide()

          this.$utils.processLoginResponse(resp)
            .then(() => {
              this.$store.state.toast.showToast(`คุณได้เข้าสู่ระบบเรียบร้อยแล้ว`, { timeLife: 1200 })
              this.$router.push(this.next())
            })
            .catch(err => {
              console.log(err)
              this.$modal.show({
                title: 'ผิดพลาด',
                text: 'ไม่สามารถดึงข้อมูลผู้ใช้ได้ กรุณาลองใหม่อีกครั้ง'
              })
            })
        })
        .catch(err => {
          console.log(err)
          this.submitting = false

          this.$modal.show({
            title: 'ผิดพลาด',
            text: 'กรุณาตรวจสอบอีเมลและรหัสผ่านใหม่อีกครั้ง'
          })
        })
    },
    login () {
      if (this.submitting) {
        return
      }

      if (!this.$v.validate()) {
        this.$forceUpdate()
        return
      }

      this.$forceUpdate()
      this.submitting = true

      const payload = {
        email: this.email,
        password: this.password
      }

      this.$modal.show({
        title: 'โปรดรอสักครู่',
        text: 'กำลังเข้าสู่ระบบ ...',
        okButton: false
      })

      this.doLogin(payload)
    }
  }
}
</script>

<style scoped>

.fb-login {
  margin-top: 8px;
  margin-bottom: 8px;
}
.login-page .container {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// LoginPage.vue?37c0589b